import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import { CollectionsBucket, collectionInfoLookup } from './FeaturedCollections';

import './FeaturedCollectionsBucket.scss';

class FeaturedCollectionsBucket extends Component {
    static propTypes = {
        currentPlace: PropTypes.string,
        isFeLoading: PropTypes.bool,
        collections: PropTypes.object,
        trackGAEventOnPageUnload: PropTypes.func,
        trackGAEvent: PropTypes.func,
    };

    render() {
        const {
            currentPlace,
            isFeLoading,
            collections,
            trackGAEvent,
            trackGAEventOnPageUnload,
        } = this.props;

        let bucketContent = null;

        if (!isFeLoading && !isEmpty(collections)) {
            const bucketsContent = Object.values(collections);
            let content = collectionInfoLookup({ bucketsContent });

            // The creator avatar is not existent in the API response so we use
            // the eventbrite logo for now
            content = content.map((collection) => ({
                ...collection,
                creatorImageIdOverrideUrl:
                    'https://cdn.evbuc.com/images/100912392/438776807040/1/original.20200513-210241',
            }));

            bucketContent = (
                <div className="featured-collections-bucket eds-bg-color--ui-200 eds-l-pad-top-10 eds-l-mar-top-10">
                    <CollectionsBucket
                        currentPlace={currentPlace}
                        content={content}
                        trackGAEvent={trackGAEvent}
                        trackGAEventOnPageUnload={trackGAEventOnPageUnload}
                    />
                </div>
            );
        }

        return bucketContent;
    }
}

export default FeaturedCollectionsBucket;
